import { render, staticRenderFns } from "./MessageCompose.vue?vue&type=template&id=d13f6fe4&scoped=true&"
import script from "./MessageCompose.vue?vue&type=script&lang=js&"
export * from "./MessageCompose.vue?vue&type=script&lang=js&"
import style0 from "./MessageCompose.vue?vue&type=style&index=0&id=d13f6fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13f6fe4",
  null
  
)

export default component.exports